module.exports = "pegasus/assets/theme4/google-icon-1.png";